import homeLayout from './../../../layouts/home/home.vue'
import store from './../../../store'

export default {
  components: {
    VLayout: homeLayout,
  },

  created () {
    store.dispatch('getTeam', {})
    store.dispatch('getTeams', {})
    store.dispatch('setHof', {})
    store.dispatch('setAthletes', {})
    store.dispatch('setAthletesSearch', {})
  },
}
